import MLSTerms, { TermsComponent } from './MLSTerms'

export default MLSTerms
export { TermsComponent }
